// extracted by mini-css-extract-plugin
export default {"root":"ApplePayButton_root__WsE-K","black":"ApplePayButton_black__G973A","white":"ApplePayButton_white__-J4u4","white-outline":"ApplePayButton_white-outline__1eB6y"};